var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-episode"},[_c('episode-form',{attrs:{"is-voice":_vm.article.content_model === 'voice',"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }